/**
 * Theme Effect Manager Component
 * Renders global effects based on theme configuration
 */

import { useLocation } from 'react-router-dom'
import { useTheme } from '@/lib/theme'
import { type ThemeEffectsConfig } from '@/utils/theme-application.util'
import { isPublicRoute } from '@/utils/route.util'
import { Snowfall } from './effects/Snowfall'
import { Sparkles } from './effects/Sparkles'
import { FloatingLights } from './effects/FloatingLights'
import { Confetti } from './effects/Confetti'
import { Fireworks } from './effects/Fireworks'
import { DiyaGlow } from './effects/DiyaGlow'
import { TricolorWave } from './effects/TricolorWave'
import { HoliColors } from './effects/HoliColors'
import { PetalFall } from './effects/PetalFall'
import { Spotlight } from './effects/Spotlight'

export function ThemeEffectManager() {
  const location = useLocation()
  const { databaseTheme, getEffectiveMode } = useTheme()

  if (isPublicRoute(location.pathname)) return null

  const effects = (databaseTheme?.config?.effects || {}) as ThemeEffectsConfig
  const currentMode = getEffectiveMode()

  return (
    <>
      {/* Global Effects */}
      {effects.global?.snowfall?.enabled && (
        <Snowfall intensity={effects.global.snowfall.intensity || 'medium'} mode={currentMode} />
      )}
      {effects.global?.sparkles?.enabled && (
        <Sparkles color={effects.global.sparkles.color} />
      )}
      {effects.global?.floatingLights?.enabled && (
        <FloatingLights intensity={effects.global.floatingLights.intensity || 'medium'} />
      )}
      {effects.global?.confetti?.enabled && (
        <Confetti colors={effects.global.confetti.colors} />
      )}
      {effects.global?.fireworks?.enabled && (
        <Fireworks intensity={effects.global.fireworks.intensity || 'medium'} />
      )}

      {/* Event effects – subtle, culturally relevant, age-appropriate */}
      {effects.eventEffects?.diyaGlow?.enabled && (
        <DiyaGlow intensity={effects.eventEffects.diyaGlow.intensity || 'low'} />
      )}
      {effects.eventEffects?.tricolorWave?.enabled && (
        <TricolorWave intensity={effects.eventEffects.tricolorWave.intensity || 'low'} />
      )}
      {effects.eventEffects?.holiColors?.enabled && (
        <HoliColors intensity={effects.eventEffects.holiColors.intensity || 'low'} />
      )}
      {effects.eventEffects?.petalFall?.enabled && (
        <PetalFall intensity={effects.eventEffects.petalFall.intensity || 'low'} />
      )}
      {effects.eventEffects?.spotlight?.enabled && (
        <Spotlight intensity={effects.eventEffects.spotlight.intensity || 'low'} />
      )}
    </>
  )
}

